<template>
  <header class="amprod-cart-header">
    <h2>Your Quote Request Cart</h2>
    <div class="amprod-cart-summary">
      <span class="cart-count">
        {{ totalItems }} {{ totalItems === 1 ? "item" : "items" }}
      </span>
      <button
        v-if="itemCount > 0"
        class="clear-cart-btn"
        @click="$emit('clear-cart')"
      >
        Clear All
      </button>
    </div>
  </header>
</template>

<script>
export default {
  name: "CartHeader",
  props: {
    totalItems: {
      type: Number,
      required: true,
    },
    itemCount: {
      type: Number,
      required: true,
    },
  },
  emits: ["clear-cart"],
};
</script>

<style scoped>
.amprod-cart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 15px;
  border-bottom: 2px solid #0073aa;
}

.amprod-cart-header h2 {
  margin: 0;
  color: #333;
}

.amprod-cart-summary {
  display: flex;
  align-items: center;
  gap: 15px;
}

.cart-count {
  font-weight: 600;
  color: #0073aa;
}

.clear-cart-btn {
  background: none;
  border: 1px solid #dc3545;
  color: #dc3545;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.3s ease;
}

.clear-cart-btn:hover {
  background-color: #dc3545;
  color: white;
}

/* Responsive design */
@media (max-width: 768px) {
  .amprod-cart-header {
    flex-direction: column;
    gap: 15px;
    align-items: flex-start;
  }
}
</style>
